/* Customs Unlimited — hero overlay + slideshow arrows
   Adds the text block and prev/next chevrons over the homepage slideshow,
   driving the theme's existing slide-show custom element.
   Purely additive — nothing in the theme is overwritten.

   THE WORDING IS EDITED IN SHOPIFY, NOT HERE:
   Online Store > Themes > Customize > Theme settings > Hero overlay
   The values below are only fallbacks, used if that panel has never
   been saved. Clearing a field in Shopify clears it on the page. */
(function () {

  var DEFAULTS = {
    eyebrow:  'Top Rated · Most Trusted · Lighting Upgrades',
    headline: 'Your one‑stop shop for automotive lighting',
    body:     'Truck, car, motorcycle, SXS/ATV, off-road, SUV, trailer and EV — thousands of lighting upgrades in one place, backed by the crew that installs them.',
    ctaText:  'Shop all lighting',
    ctaHref:  '/collections/all'
  };

  /* null/undefined means the setting has never been saved, so fall back.
     An empty string means the merchant deliberately cleared it. */
  function pick(value, fallback) {
    return (value === null || value === undefined) ? fallback : value;
  }

  var cfg = window.CU_HERO || {};

  var HERO = {
    show:     cfg.show === false ? false : true,
    eyebrow:  pick(cfg.eyebrow,  DEFAULTS.eyebrow),
    headline: pick(cfg.headline, DEFAULTS.headline),
    body:     pick(cfg.body,     DEFAULTS.body),
    ctaText:  pick(cfg.ctaText,  DEFAULTS.ctaText),
    ctaHref:  pick(cfg.ctaHref,  DEFAULTS.ctaHref) || DEFAULTS.ctaHref
  };

  function esc(s) {
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function chevron(dir) {
    var d = dir === 'next'
      ? 'M9 6l6 6-6 6M3 6l6 6-6 6'
      : 'M15 6l-6 6 6 6M21 6l-6 6 6 6';
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
           'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>';
  }

  function addOverlay(show) {
    if (!HERO.show) return;
    if (show.querySelector('.cu-hero-overlay')) return;
    if (!HERO.eyebrow && !HERO.headline && !HERO.body && !HERO.ctaText) return;

    var wrap = document.createElement('div');
    wrap.className = 'cu-hero-overlay';

    var html = '<div class="cu-hero-overlay__inner">';
    if (HERO.eyebrow)  html += '<p class="cu-hero__eyebrow">' + esc(HERO.eyebrow) + '</p>';
    if (HERO.headline) html += '<h1 class="cu-hero__title">' + esc(HERO.headline) + '</h1>';
    if (HERO.body)     html += '<p class="cu-hero__body">' + esc(HERO.body) + '</p>';
    if (HERO.ctaText)  html += '<a class="cu-hero__cta" href="' + esc(HERO.ctaHref) + '">' + esc(HERO.ctaText) + '</a>';
    html += '</div>';

    wrap.innerHTML = html;
    show.appendChild(wrap);
  }

  function addArrows(show) {
    if (show.querySelector('.cu-slide-nav')) return;
    if (show.querySelectorAll('.slideshow__slide').length < 2) return;

    var nav = document.createElement('div');
    nav.className = 'cu-slide-nav';
    nav.innerHTML =
      '<button type="button" data-cu="prev" aria-label="Previous slide">' + chevron('prev') + '</button>' +
      '<button type="button" data-cu="next" aria-label="Next slide">' + chevron('next') + '</button>';

    nav.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cu]');
      if (!btn) return;
      e.preventDefault();
      if (btn.getAttribute('data-cu') === 'next') {
        if (typeof show.showNextSlide === 'function') show.showNextSlide();
      } else {
        if (typeof show.showPrevSlide === 'function') show.showPrevSlide();
      }
    });

    show.appendChild(nav);
  }

  function init() {
    var shows = document.querySelectorAll('.cc-slideshow slide-show');
    for (var i = 0; i < shows.length; i++) {
      addOverlay(shows[i]);
      addArrows(shows[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* re-run when the theme editor re-renders the section, so edits in
     Customize show up straight away without a reload */
  document.addEventListener('shopify:section:load', init);
})();
